//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IconView from "@/components/objects/IconView.vue";

export default {
  name: 'TheBurgerMenu',

  components: { IconView },

  props: {
    blocks: {
      type: Array,
      required: true,
    },
    separatorStyles: {
      type: [Object, null],
      default: () => {}
    },
    fontColorStyles: {
      type: Object,
      default: () => {}
    },
    menuBgStyles: {
      type: Object,
      default: () => {}
    },
    icon: {
      type: String,
      required: false,
    }
  },

  data() {
    return {
      visible: false,
    };
  },

  methods: {
    afterVisibleChange(val) {},
    onOpen() {
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    },
    onLink(label, event) {
      event.preventDefault();
      event.stopPropagation();
      this.onClose();
      this.$emit('link-tag', label.replaceAll(' ', '-').replaceAll('"', ''));
      return false;
    },
  }
}
